import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

/**
 * ReleaseGroupsReleaseSelectorRowLoading is displayed for a single row
 * when the release selector is loading releases.
 */
const ReleaseGroupsReleaseSelectorRowLoading: VoidFunctionComponent = () => (
  <ContentLoader width="100%" height="30px">
    <rect x="8" y="8" rx="3" ry="3" width="94%" height="20" />
  </ContentLoader>
);

export default ReleaseGroupsReleaseSelectorRowLoading;
